export default {"src":"/_next/static/media/onlineProfile.0925d26a.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};